// Get Code Details
export const GET_CODE_DETAILS_REQUEST = 'GET_CODE_DETAILS_REQUEST';
export const GET_CODE_DETAILS_DONE = 'GET_CODE_DETAILS_DONE';
export const GET_CODE_DETAILS_FAILED = 'GET_CODE_DETAILS_FAILED';
